import { createContext, ReactElement, useContext } from 'react';
import { TEventsConfigs } from 'interfaces/events';

type TEventsConfigsWithComponentId = TEventsConfigs & { componentId: string };

export type TEventsConfigsContext = TEventsConfigsWithComponentId | null;

type TConfigsProviderProps = {
  configs: TEventsConfigsWithComponentId;
  children: ReactElement | ReactElement[];
};

const EventsConfigsContext = createContext<TEventsConfigsContext>(null);

export const EventsConfigsProvider = ({
  configs,
  children
}: TConfigsProviderProps): ReactElement => {
  return (
    <EventsConfigsContext.Provider value={configs}>
      {children}
    </EventsConfigsContext.Provider>
  );
};

export const useEventsConfigs = (): TEventsConfigsContext => {
  return useContext(EventsConfigsContext);
};
